import CustomModal from './CustomModal';
import { useState } from 'react';
import { Dropzone } from './Dropzone';
import { FileWithPath } from 'react-dropzone';
import { DocumentCard } from './DocumentCard';
import { createDosageDiaryProfile } from '../service/createDosageDiaryProfile';
import showToast from './ToastComponent';
import { DosageDiaryUploaderProps } from '../interface/interface';

export function DosageDiaryUploader({
  token,
  setUploaderVisibility,
  isUploaderVisible,
  fetchTrigger,
}: DosageDiaryUploaderProps) {
  const [files, setFiles] = useState<Array<FileWithPath>>([]);
  const [profileName, setProfileName] = useState<string>();

  async function uploadFile() {
    const result = await createDosageDiaryProfile(token, {
      name: profileName!,
      file: files[0],
    });
    if (typeof result === 'number' && result === 201) {
      setFiles([]);
      setProfileName(undefined);
      showToast({
        type: 'success',
        message: 'Dosage Diary Profile Created',
      });
      setUploaderVisibility(false);
      fetchTrigger();
    } else {
      showToast({
        type: 'info',
        message: result.toString(),
      });
    }
  }

  return (
    <>
      <CustomModal
        isOpen={isUploaderVisible}
        onClose={() => setUploaderVisibility(false)}
        header="Create Dosage Diary Profile"
        footer={
          <button
            className={`text-base px-6 py-3 text-white rounded-md 
              ${profileName === '' || !files.length ? 'bg-secondary-cornflowerblue-400 cursor-not-allowed' : 'bg-secondary-cornflowerblue-600'}`}
            onClick={async () => await uploadFile()}
            disabled={profileName === '' || !files.length}
          >
            Upload
          </button>
        }
        modalSize="w-5/12"
      >
        <div className="sm:col-span-2 mt-2 mb-4">
          <label
            htmlFor="first-name"
            className="text-sm  text-secondary-pink-700"
          >
            Profile Name <span className="text-red-500">*</span>
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="profileName"
              id="profile-name"
              className={`text-sm font-regular border  
                        rounded-md p-2 w-full 
                        ${
                          profileName === ''
                            ? 'border-red-400'
                            : 'border-secondary-cornflowerblue-400'
                        }`}
              value={profileName}
              onChange={(e) => setProfileName(e.target.value)}
            />
          </div>
          {profileName === '' && (
            <small className="text-red-600">Profile Name is required</small>
          )}
        </div>
        <Dropzone
          setAcceptedFiles={(uploadedFiles) => setFiles(uploadedFiles)}
          type="Dosage Diary Document (PDF)"
        />
        <div className="py-2">
          <DocumentCard
            item={files.map((file) => ({
              name: file.name,
              size: (file.size / (1024 * 1024))?.toFixed(2) + ' MB',
              onDelete: () => setFiles([]),
            }))}
          />
        </div>
      </CustomModal>
    </>
  );
}
